import { h, render } from 'preact';
import picostyle from 'picostyle';

const style = picostyle(h);

export const Button = style('a')(props => {
  if (props.className) return;

  const buttonStyles = {
    display: 'inline-block',
    padding: '9px 15px',
    backgroundColor: '#3898EC',
    color: 'white',
    border: '0',
    lineHeight: 'inherit',
    textDecoration: 'none',
    cursor: 'pointer',
    borderRadius: '0',
    fontWeight: 'normal',
    fontSize: 'inherit',
  };

  const primary = {
    display: 'inline-block',
    marginTop: '15px',
    padding: '5px 20px',
    backgroundColor: '#60b34a',
    WebkitTransition: 'all 150ms ease',
    transition: 'all 150ms ease',

    '&:hover': {
      'background-color': '#000'
    }
  };

  const simple = {
    display: 'inline-block',
    marginTop: '15px',
    marginLeft: '10px',
    padding: '5px 20px',
    backgroundColor: 'transparent',
    WebkitTransition: 'all 150ms ease',
    transition: 'all 150ms ease',
    '&:hover': {
      color: '#000'
    }
  };

  let styles = {};

  if (props.primary) {
    styles = { ...buttonStyles, ...primary };
  } else if (props.simple) {
    styles = { ...buttonStyles, ...simple };
  } else {
    styles = buttonStyles;
  }

  const propsStyles = {};
  const { hover } = props;
  if (props.color) propsStyles.color = props.color;
  if (props.background) propsStyles.background = props.background;
  if (props.border) propsStyles.border = props.border;

  styles = { ...styles, ...propsStyles };
  if (hover) {
    styles['&:hover'] = { ...styles['&:hover'], ...hover };
  }

  return styles;
});
